import { GameManual } from '../types';
import { onMarsManual } from './onMars';
import { arkNovaManual } from './arkNova';
import { vinhosDeluxeLegacyManualStub } from '../games/vinhos-deluxe/legacyManualStub';
import { laFamigliaLegacyManualStub } from '../games/la-famiglia/legacyManualStub';
import { odinDeluxeLegacyManualStub } from '../games/a-feast-for-odin/legacyManualStub';
import { carcassonneLegacyManualStub } from '../games/carcassonne/legacyManualStub';
import { getVerifiedRulebook } from './verified-rulebooks';
import { barrageManual } from './barrage';

/**
 * Shared GameManual map — no image requires / Node APIs.
 * Modular games (Vinhos, Carcassonne, …) keep empty legacy stubs here;
 * their full content lives in game modules and is adapted by the PWA layer.
 */
export const gameManuals: Record<string, GameManual> = {
  'nieswiadomy-umysl': getVerifiedRulebook('nieswiadomy-umysl')!,
  'spirit-island': getVerifiedRulebook('spirit-island')!,
  'on-mars': onMarsManual,
  'la-famiglia': laFamigliaLegacyManualStub,
  'uczta-dla-odyna': odinDeluxeLegacyManualStub,
  'diuna-imperium': getVerifiedRulebook('diuna-imperium')!,
  'weather-machine': getVerifiedRulebook('weather-machine')!,
  barrage: barrageManual,
  'vinhos-deluxe': vinhosDeluxeLegacyManualStub,
  voidfall: getVerifiedRulebook('voidfall')!,
  'ark-nova': arkNovaManual,
  carcassonne: carcassonneLegacyManualStub,
  'projekt-gaja': getVerifiedRulebook('projekt-gaja')!,
};
